import { Select } from "antd";
import {
  SUPPORTED_FONT_FAMILIES,
  THEME_FONT_FAMILY,
  resolveFontFamily
} from "constants/style.constants";

import { ChartSettingsGroups, ControlDef, SettingsGroups } from "./controlDefinition";

const { Option } = Select;

// ── Quick Actions ─────────────────────────────────────────

export const LEGEND_TOGGLE: ControlDef = {
  name: "legendVisible",
  label: "Chart Legend",
  group: SettingsGroups.quick,
  input: { type: "boolean" },
  visibility: "always"
};

export const ABBREVIATIONS_TOGGLE: ControlDef = {
  name: "applyAbbreviations",
  label: "Use Abbreviations",
  group: SettingsGroups.quick,
  input: { type: "boolean" },
  visibility: "standalone"
};

// ── Font Size Presets (shared by MPC, SAM, Chart) ─────────

export const CHART_FONT_SIZE_PRESETS: readonly ControlDef[] = [
  {
    name: "titleFontSize",
    label: "Title Size",
    group: SettingsGroups.preset,
    input: { type: "number", min: 0, unit: "pt" },
    visibility: "standalone"
  },
  {
    name: "axisFontSize",
    label: "Axis Title Size",
    group: SettingsGroups.preset,
    input: { type: "number", min: 0, unit: "pt" },
    visibility: "standalone"
  },
  {
    name: "axisLabelFontSize",
    label: "Axis Labels Size",
    group: SettingsGroups.preset,
    input: { type: "number", min: 0, unit: "pt" },
    visibility: "standalone"
  },
  {
    name: "legendFontSize",
    label: "Legend Labels Size",
    group: SettingsGroups.preset,
    input: { type: "number", min: 0, unit: "pt" },
    visibility: "standalone"
  }
];

// ── MPC-specific controls ─────────────────────────────────

export const MPC_TITLE_TEXT: ControlDef = {
  name: "titleText",
  label: "Title",
  group: ChartSettingsGroups.title,
  input: { type: "text" },
  visibility: "standalone"
};

export const MPC_AXIS_FONT_WEIGHT: ControlDef = {
  name: "axisFontWeight",
  label: "Title Font Weight",
  group: ChartSettingsGroups.axis,
  input: { type: "number", step: 100, min: 100 },
  visibility: "standalone"
};

/** Font family select — custom rendering for font preview. */
export const fontFamilyControl = (
  group: string = ChartSettingsGroups.advanced
): ControlDef => ({
  name: "fontFamily",
  label: "Font Family",
  group,
  input: { type: "text" },
  visibility: "always",
  valuePropName: "value",
  renderChild: () => (
    <Select defaultValue={THEME_FONT_FAMILY} style={{ width: "100%" }}>
      {SUPPORTED_FONT_FAMILIES.map((option) => (
        <Option key={option.value} value={option.value} label={option.label}>
          <span style={{ fontFamily: resolveFontFamily(option.value) }}>
            {option.label}
          </span>
        </Option>
      ))}
    </Select>
  )
});
